import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdd1475a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-basket-page" }
const _hoisted_2 = { class: "reserved-order-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-plusv2 fs-18" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "action",
  type: "button"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-copy fs-18" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-print fs-18" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "m-auto"
}
const _hoisted_8 = {
  key: 0,
  class: "basket-total"
}
const _hoisted_9 = { class: "basket-total-first" }
const _hoisted_10 = { class: "border-bottom" }
const _hoisted_11 = { class: "total-title" }
const _hoisted_12 = { class: "total-value" }
const _hoisted_13 = { class: "total-title" }
const _hoisted_14 = { class: "total-value" }
const _hoisted_15 = { class: "basket-total-second" }
const _hoisted_16 = { class: "border-bottom" }
const _hoisted_17 = { class: "total-title" }
const _hoisted_18 = { class: "total-value" }
const _hoisted_19 = { class: "total-title" }
const _hoisted_20 = { class: "total-value" }
const _hoisted_21 = { class: "basket-total-third" }
const _hoisted_22 = { class: "border-bottom" }
const _hoisted_23 = { class: "total-title" }
const _hoisted_24 = { class: "total-value" }
const _hoisted_25 = { class: "total-title" }
const _hoisted_26 = { class: "total-value" }
const _hoisted_27 = { class: "basket-total-fourth" }
const _hoisted_28 = { class: "total-title" }
const _hoisted_29 = { class: "total-value" }
const _hoisted_30 = {
  key: 2,
  class: "basket-footer-actions"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-save pr-8" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-12 pr-8" }, null, -1))
const _hoisted_33 = {
  key: 3,
  class: "basket-footer-actions2"
}
const _hoisted_34 = {
  key: 0,
  form: "customerDetails",
  type: "submit",
  style: {"background":"#129456"}
}
const _hoisted_35 = {
  key: 1,
  form: "customerDetails",
  type: "submit",
  style: {"background":"#129456"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-pay fs-16 pr-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasketItems = _resolveComponent("BasketItems")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.orderId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "action",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewProduct()))
            }, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.add-product")), 1)
            ]),
            false
              ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.order-copy")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "action",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printTicketAction()))
            }, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.print")), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.products.length > 0)
      ? (_openBlock(), _createBlock(_component_BasketItems, {
          key: 0,
          products: _ctx.products,
          notAvailableProducts: _ctx.notAvailableProducts
        }, null, 8, ["products", "notAvailableProducts"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7)),
    _createElementVNode("div", null, [
      (_ctx.orderId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("cashier.label.gross")) + " ", 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatAmount(_ctx.totalWithOutDiscount)) + " " + _toDisplayString(_ctx.currencySign), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("cashier.label.discount")) + ": ", 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatAmount(_ctx.amountDiscount)) + " " + _toDisplayString(_ctx.currencySign), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("cashier.label.commission")) + " ", 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.order.commissionPercent) + "%", 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("cashier.label.total")) + " ", 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatAmount(_ctx.total)) + " " + _toDisplayString(_ctx.currencySign), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("cashier.label.net")) + " ", 1),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatAmount(_ctx.totalWithOutDiscount - _ctx.order.commissionTotal)) + " " + _toDisplayString(_ctx.currencySign), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("cashier.label.paid")) + ": ", 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatAmount(_ctx.order.receiptTotal)) + " " + _toDisplayString(_ctx.currencySign), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("cashier.label.balance")), 1),
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatAmount(
                _ctx.totalWithOutDiscount - _ctx.amountDiscount - _ctx.order.receiptTotal
              )) + " " + _toDisplayString(_ctx.currencySign), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isSave == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _withDirectives(_createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveOrderAction && _ctx.saveOrderAction(...args)))
          }, [
            _hoisted_31,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.save")), 1)
          ], 512), [
            [_vShow, _ctx.orderId]
          ]),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkOut && _ctx.checkOut(...args)))
          }, [
            _hoisted_32,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.check-out")), 1)
          ], 512), [
            [_vShow, _ctx.orderId]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
          (_ctx.isSave)
            ? (_openBlock(), _createElementBlock("button", _hoisted_34, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.ok")), 1)
              ]))
            : (_openBlock(), _createElementBlock("button", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.pay")), 1)
              ]))
        ]))
  ]))
}